export default "__VITE_ASSET__DO76FQpW__"